import { ProcessingTicketingDataState } from '../graphql';
import { useFiscalYearOrFail } from './useFiscalYear';
import { useSelectedFiscalYearId } from './useSelectedFiscalYearId';

export const useHasSkippedConnectingTicketing = (): { hasSkippedConnectingTicketing: boolean } => {
  const fiscalYearId = useSelectedFiscalYearId();
  const { fiscalYear } = useFiscalYearOrFail({ fiscalYearId });

  return {
    hasSkippedConnectingTicketing: fiscalYear.processingTicketingDataState === ProcessingTicketingDataState.Skipped,
  };
};
